import React from 'react'
import { Modal } from 'antd';
import { Button } from '@digital/ui'
import { ordemCompraIdState, reloadWidgetTimelineState } from '../atoms'
import { useRecoilState, useRecoilValue } from 'recoil';
import { enviarEmailCartaAgradecimento } from '@app/api/sas/ordemCompra';
interface Props {
    disabled: boolean
}

const ButtonModalEnvioCartaAgradecimento = ({disabled}: Props) => {
    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const [reloadWidgetTimeline, setReloadWidgetTimeline] = useRecoilState(reloadWidgetTimelineState);

    const onConcordar = () => {
        Modal.confirm({
            title: 'Confirmação Envio de Email',
            content: 'Você deseja enviar este e-mail?',
            cancelText: 'Não',
            onCancel: () => {
                enviarEmailCartaAgradecimento(ordemCompraId, false)
                    .then((data: any) => {
                        if (data) {
                            setReloadWidgetTimeline(!reloadWidgetTimeline);
                        }
                    })
            },
            okText: 'Sim',
            onOk: () => {
                enviarEmailCartaAgradecimento(ordemCompraId, true)
                    .then((data: any) => {
                        if (data) {
                            setReloadWidgetTimeline(!reloadWidgetTimeline);
                        }
                    })
            },
        });
    }

    return (
        <>
            <Button
                title='Envio Carta de Agradecimento'
                className={disabled ? 'button-modal-acoes-gerais-disabled' : ''}
                disabled={disabled}
                onClick={() => {
                    Modal.confirm({
                        title: 'Confirmar envio',
                        content:
                            'Confirma envio da Carta de Agradecimento?',
                        cancelText: 'Cancelar',
                        okText: 'Confirmar',
                        onOk: () => {
                            onConcordar();
                        },
                    });
                }}
            />
        </>
    )
}

export default ButtonModalEnvioCartaAgradecimento